import axiosPost from "./axiosPost";

export const RNHZonaDel = async (credentials, data) => {
    const body = {
        service: "RNHZonaDel",
        params: {
            rnhZonaId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
